import type { IRegionResponse } from '@escloud/types';

import type { ApiClient } from './api-client';

export class RegionsService {
    constructor(private api: ApiClient) {}

    getRegions(): Promise<{ items: IRegionResponse[] }> {
        return this.api.get<{ items: IRegionResponse[] }>('/regions', { skipAuth: true });
    }
}
